"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.myYup = void 0;
const yup = __importStar(require("yup"));
const fraction_js_1 = __importDefault(require("fraction.js"));
const isFraction = (msg) => yup.mixed().test({
    name: "equalTo",
    exclusive: false,
    message: msg || "number, decimals, and fractions only",
    test(value) {
        if (!value) {
            return true;
        }
        try {
            fraction_js_1.default(typeof value === "string" ? value.trim() : value);
            return true;
        }
        catch (err) {
            return false;
        }
    }
});
yup.addMethod(yup.string, "isFraction", isFraction);
const frequency = (x, str) => {
    let count = -1;
    for (let index = 0; index !== -1; count += 1, index = str.indexOf(x, index + 1))
        ;
    return count;
};
const maxFrequency = (_, n, msg) => yup.mixed().test({
    name: "equalTo",
    exclusive: false,
    message: msg,
    test(value) {
        return frequency("\n", value) <= n;
    }
});
yup.addMethod(yup.string, "maxFrequency", maxFrequency);
exports.default = yup;
exports.myYup = yup;
//# sourceMappingURL=instance.js.map